var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#516AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2859 7.01944L11.5234 7.7265V4.19062L9.04838 2.95312L5.20312 5.11875V12.8087L9.04838 15.0188L12.8492 12.7648V8.964L9.18056 6.75394L7.94306 7.37269L11.6117 9.53831L11.6556 12.1461L9.04838 13.6046L6.39619 12.1016V5.7375L9.04838 4.27894L10.2859 4.94213V7.01944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91562 9.14062L9.75544 8.6985L10.6836 9.27337L7.94306 10.8202V7.63818L8.91562 8.2125",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBand);
export default __webpack_public_path__ + "static/media/band.9a5953198b5834ee8cc0ddc663cf7ef1.svg";
export { ForwardRef as ReactComponent };